module.exports = __webpack_public_path__ + "img/wave.594d98d.jpg";